import React from 'react';
import styles from './index.module.less';
import classNames from 'classnames';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';

interface EmptyPageProps {
  src?: string;
  text?: string | React.ReactNode;
  textColor?: string;
  fontSize?: number;
  style?: React.CSSProperties;
  boxShadow?: boolean;
}

const EmptyPage = ({ src = '/images/no-data.webp', text, boxShadow = true }: EmptyPageProps) => {
  const { t } = useTranslation();

  return (
    <div className={classNames([styles.container, boxShadow && styles.shadow])}>
      <div className={styles.content}>
        {src?.length > 0 && (
          <Image
            className={styles.imgItem}
            src={src}
            alt="Empty"
            loading="lazy"
            width={80}
            height={80}
            layout="responsive"
          />
        )}
        <div className={styles.titleItem}>{text || t('emptyData')}</div>
      </div>
    </div>
  );
};

export default EmptyPage;
